import { Box, Button, Avatar, SegmentedControl } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const width = '288px';
export const smallScreenwidth = '240px';

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export interface SegmentedControlStyledProps {
  disabled: boolean;
}

export const ColStyled = styled(Box).attrs({ flexDirection: { sm: 'column' }, mx: { sm: '400' }, mt: { sm: '450' } })`
  ${({ theme }) => css`
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
    border-radius: ${theme.radii[200]};
  `}
`;

export const CrewListStyled = styled(ColStyled)`
  min-width: ${width};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    min-width: ${smallScreenwidth};
  }
`;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
  `}
`;

export const HeaderStyled = styled(Box).attrs({
  px: { sm: '500' },
  pb: { sm: '500' },
  pt: { sm: '600' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.grey[200]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;

export const CommentStyled = styled(Box).attrs({ px: { sm: '500' }, pt: { sm: '500' } })`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacings[500]};
    @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
      padding-bottom: ${theme.spacings[500]};
    }
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.widescreen}) and (max-width: ${({ theme }) =>
        theme.breakpoints.fullHD}) {
      padding-bottom: ${theme.spacings[500]};
    }
  `}
`;

export const SegmentedControlStyled = styled(SegmentedControl)<SegmentedControlStyledProps>`
  width: 130px;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;
